'use client';
import React, { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const navLinks = [
    { label: 'Home', href: '/' },
    { label: 'About Marie', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Client Login', href: '/login' },
  ];

  return (
    <header data-component-id="src/components/Header.tsx:29:4" data-component-path="src/components/Header.tsx" data-component-line="29" data-component-end-line="136" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-ivory/95 backdrop-blur-md shadow-sm border-b border-warm-gray-light/40'
          : 'bg-ivory/80 backdrop-blur-sm'
      }`}
    >
      <div data-component-id="src/components/Header.tsx:36:6" data-component-path="src/components/Header.tsx" data-component-line="36" data-component-end-line="102" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-6xl%20mx-auto%20px-6%20py-4%20flex%20items-center%20justify-between%22%7D" className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <a data-component-id="src/components/Header.tsx:38:8" data-component-path="src/components/Header.tsx" data-component-line="38" data-component-end-line="44" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%2F%22%7D" href="/" aria-label="Marie Paul Chemistry Tutoring">
          <img data-component-id="src/components/Header.tsx:39:10" data-component-path="src/components/Header.tsx" data-component-line="39" data-component-end-line="43" data-component-file="Header.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%2Fassets%2Fimages%2Fmarie_paul_mp_complete.svg%22%2C%22alt%22%3A%22Marie%20Paul%20Chemistry%20Tutoring%22%2C%22className%22%3A%22h-12%20w-auto%22%7D"
            src="/assets/images/marie_paul_mp_complete.svg"
            alt="Marie Paul Chemistry Tutoring"
            className="h-12 w-auto"
          />
        </a>

        {/* Desktop Nav */}
        <nav data-component-id="src/components/Header.tsx:47:8" data-component-path="src/components/Header.tsx" data-component-line="47" data-component-end-line="65" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22hidden%20md%3Aflex%20items-center%20gap-8%22%7D" className="hidden md:flex items-center gap-8" aria-label="Main navigation">
          {navLinks.map((link) => {
            const isActive = pathname === link.href;
            return (
              <a data-component-id="src/components/Header.tsx:51:14" data-component-path="src/components/Header.tsx" data-component-line="51" data-component-end-line="62" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
                key={link.href}
                href={link.href}
                className={`text-sm font-medium transition-colors duration-200 ${
                  isActive
                    ? 'text-navy border-b border-navy pb-0.5'
                    : 'text-charcoal-light hover:text-navy'
                }`}
                aria-current={isActive ? 'page' : undefined}
              >
                {link.label}
              </a>
            );
          })}
        </nav>

        {/* CTA */}
        <a data-component-id="src/components/Header.tsx:68:8" data-component-path="src/components/Header.tsx" data-component-line="68" data-component-end-line="74" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%2Fbook%22%2C%22className%22%3A%22hidden%20md%3Ainline-flex%20items-center%20bg-gold%20text-navy%20text-sm%20font-medium%20px-5%20py-2.5%20rounded%5Cn%20%20%20%20%20%20%20%20%20%20%20%20hover%3Abg-gold-dark%20transition-all%20duration-200%20border%20border-gold%20hover%3Aborder-gold-dark%22%2C%22textContent%22%3A%22Book%20a%20Free%20Consultation%22%7D"
          href="/book"
          className="hidden md:inline-flex items-center bg-gold text-navy text-sm font-medium px-5 py-2.5 rounded
            hover:bg-gold-dark transition-all duration-200 border border-gold hover:border-gold-dark"
        >
          Book a Free Consultation
        </a>

        {/* Mobile hamburger */}
        <button data-component-id="src/components/Header.tsx:77:8" data-component-path="src/components/Header.tsx" data-component-line="77" data-component-end-line="101" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22md%3Ahidden%20p-2%20text-navy%22%7D"
          className="md:hidden p-2 text-navy"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <svg data-component-id="src/components/Header.tsx:83:10" data-component-path="src/components/Header.tsx" data-component-line="83" data-component-end-line="100" data-component-file="Header.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            {menuOpen ? (
              <path data-component-id="src/components/Header.tsx:92:14" data-component-path="src/components/Header.tsx" data-component-line="92" data-component-end-line="92" data-component-file="Header.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
            ) : (
              <>
                <line data-component-id="src/components/Header.tsx:95:16" data-component-path="src/components/Header.tsx" data-component-line="95" data-component-end-line="95" data-component-file="Header.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="3" y1="6" x2="21" y2="6" strokeLinecap="round" />
                <line data-component-id="src/components/Header.tsx:96:16" data-component-path="src/components/Header.tsx" data-component-line="96" data-component-end-line="96" data-component-file="Header.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="3" y1="12" x2="21" y2="12" strokeLinecap="round" />
                <line data-component-id="src/components/Header.tsx:97:16" data-component-path="src/components/Header.tsx" data-component-line="97" data-component-end-line="97" data-component-file="Header.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="3" y1="18" x2="21" y2="18" strokeLinecap="round" />
              </>
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu — animated slide */}
      <div data-component-id="src/components/Header.tsx:105:6" data-component-path="src/components/Header.tsx" data-component-line="105" data-component-end-line="135" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        className={`md:hidden bg-ivory border-t border-warm-gray-light/40 overflow-hidden transition-all duration-300 ease-in-out ${
          menuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0 pointer-events-none'
        }`}
        aria-hidden={!menuOpen}
      >
        <div data-component-id="src/components/Header.tsx:111:8" data-component-path="src/components/Header.tsx" data-component-line="111" data-component-end-line="134" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22px-6%20py-4%20flex%20flex-col%20gap-4%22%7D" className="px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => {
            const isActive = pathname === link.href;
            return (
              <a data-component-id="src/components/Header.tsx:115:14" data-component-path="src/components/Header.tsx" data-component-line="115" data-component-end-line="124" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
                key={link.href}
                href={link.href}
                className={`text-sm font-medium transition-colors duration-200 ${
                  isActive ? 'text-navy' : 'text-charcoal-light hover:text-navy'
                }`}
                aria-current={isActive ? 'page' : undefined}
              >
                {link.label}
              </a>
            );
          })}
          <a data-component-id="src/components/Header.tsx:127:10" data-component-path="src/components/Header.tsx" data-component-line="127" data-component-end-line="133" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%2Fbook%22%2C%22className%22%3A%22inline-flex%20items-center%20justify-center%20bg-navy%20text-ivory%20text-sm%20font-medium%20px-5%20py-2.5%20rounded%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20hover%3Abg-gold%20hover%3Atext-navy%20transition-all%20duration-200%20mt-2%22%2C%22textContent%22%3A%22Book%20a%20Free%20Consultation%22%7D"
            href="/book"
            className="inline-flex items-center justify-center bg-navy text-ivory text-sm font-medium px-5 py-2.5 rounded
              hover:bg-gold hover:text-navy transition-all duration-200 mt-2"
          >
            Book a Free Consultation
          </a>
        </div>
      </div>
    </header>
  );
}
